const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const BarGraph = require("./GradeBarGraph");

const styles = require("./styles/GradeGraph.css");

module.exports = createReactClass({
	displayName: "GradeGraph",

	propTypes: {
		className: PT.string,
		gradeID: PT.number.isRequired,
		continuous: PT.bool,
		backgroundColor: PT.string,
		// Array of arrays of bar data for all chapters.
		// Bar data is array of stars earned: 0-3.
		barDataChapters: PT.array.isRequired,
		disableResponsive: PT.bool,
	},

	renderChapterBar: function(chapterNumber, barData) {
		const chapterClass = this.props.disableResponsive
			? styles.chapter
			: styles.chapterResponsive;
		return (
			<div className={chapterClass} key={"graph" + chapterNumber}>
				<BarGraph
					gradeID={this.props.gradeID}
					barData={barData}
					isVertical={true}
					isSorted={true}
					continuous={this.props.continuous}
					backgroundColor={this.props.backgroundColor}
				/>
				<div className={styles.label}>{chapterNumber}</div>
			</div>
		);
	},

	render: function() {
		const {className, barDataChapters} = this.props;
		const bars = barDataChapters.map((data, i) =>
			this.renderChapterBar(i + 1, data)
		);

		return <div className={styles.main + " " + className}>{bars}</div>;
	},
});
